module.exports = __webpack_public_path__ + "static/service-accessibility-9ce5cfab8488c893363ca1d16cf23fec.jpg";